export class Ga4EventService {
  private ensureDataLayer(): void {
    window.dataLayer = window.dataLayer || [];
  }

  public fireEvent<T extends Record<string, unknown>>(
    eventName: string,
    eventData?: T,
  ): void {
    this.ensureDataLayer();

    const eventPayload: Record<string, unknown> = {
      event: eventName,
    };

    if (eventData) {
      Object.assign(eventPayload, eventData);
    }

    window.dataLayer.push(eventPayload);
  }
}

export const ga4EventService = new Ga4EventService();
